__turbopack_context__.v({
  "className": "montserrat_6a9bfbca-module__4xPLkq__className",
});
